<div class="container fw-b">
  <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems"></app-linker-route>
</div>

<div class="edit-profile-shell">
  <section class="profile-hero edit-hero">
    <div class="profile-hero__cover"></div>
    <div class="profile-hero__content">
      <div class="identity-card">
        <div class="avatar-upload">
          <div class="avatar-upload__frame">
            <img [src]="imageUrl || 'assets/images/man.png'" alt="Profile Picture" />
            <label class="camera-trigger">
              <i class="fa fa-camera"></i>
              <input type="file" class="input-file" accept=".png, .jpg, .jpeg" (change)="uploadImg($event)" />
            </label>
          </div>
          <div class="identity-card__copy">
            <h1>{{profileData?.firstName}} {{profileData?.lastName}}</h1>
            <p>{{profileData?.email}}</p>
          </div>
        </div>

        <div class="pill-group">
          <span class="pill pill-primary" *ngIf="profileData?.userType">
            {{ profileData?.userType | titlecase }}
          </span>
          <span class="pill pill-soft" *ngIf="profileData?.city || profileData?.country">
            {{ profileData?.city || '-' }}, {{ profileData?.country || '-' }}
          </span>
        </div>
      </div>

      <div class="edit-hero__side">
        <div class="campaign-card" *ngIf="userRole != 'SERVICE_PROVIDER'">
          <div>
            <p class="campaign-eyebrow">Campaign Preference</p>
            <h3>Choose how you want to be contacted</h3>
          </div>
          <select class="campaign-select" [(ngModel)]="campain">
            <option value="">Select an option</option>
            <option value="MANUAL">Manual</option>
            <option value="AUTOMATIC">Automatic</option>
            <option value="SEMI_AUTOMATIC">Semi Automatic</option>
          </select>
        </div>
      </div>
    </div>
  </section>

  <section class="profile-details-card edit-form-card">
    <div class="details-header">
      <div>
        <p class="eyebrow-text">Customer Center</p>
        <h2>Edit Profile</h2>
      </div>
      <span class="badge-live">Active</span>
    </div>

    <form [formGroup]="addProduct" class="edit-form">
      <div class="form-section">
        <div class="section-heading">
          <h3>Personal Information</h3>
        </div>
        <div class="form-grid form-grid--two">
          <div class="form-field">
            <label class="form-label">First Name<span class="astrict">*</span></label>
            <input type="text" placeholder="Enter first name" formControlName="fName" maxlength="62"
              (keypress)="preventSpace($event)" class="form-control form-control-small" />
            <div class="for-validation text-danger"
              *ngIf="addProduct.get('fName')?.hasError('required') && addProduct.get('fName')?.touched ">
              *Please enter first name.</div>
            <div class="for-validation text-danger"
              *ngIf="addProduct.get('fName')?.hasError('minlength') && addProduct.get('fName')?.dirty ">
              *Please enter minimum 2 character.</div>
          </div>

          <div class="form-field">
            <label class="form-label">Last Name<span class="astrict">*</span></label>
            <input type="text" placeholder="Enter last name" formControlName="lName"
              maxlength="250" (keypress)="preventSpace($event)" class="form-control form-control-small" />
            <div class="for-validation text-danger"
              *ngIf="addProduct.get('lName')?.hasError('required') && addProduct.get('lName')?.touched ">
              *Please enter last name.</div>
            <div class="for-validation text-danger"
              *ngIf="addProduct.get('lName')?.hasError('minlength') && addProduct.get('lName')?.dirty ">
              *Please enter minimum 2 character.</div>
          </div>

          <div class="form-field">
            <label class="form-label">Email<span class="astrict">*</span></label>
            <input type="text" placeholder="Enter your email" formControlName="email" maxlength="250"
              (keypress)="preventSpace($event)" class="form-control form-control-small" />
            <div class="for-validation text-danger"
              *ngIf="addProduct.get('email')?.hasError('required') && addProduct.get('email')?.touched ">
              *Email is required.</div>
            <div class="for-validation text-danger"
              *ngIf="addProduct.get('email')?.hasError('pattern') && addProduct.get('email')?.dirty ">
              *Please enter a valid email.</div>
          </div>

          <div class="form-field">
            <label class="form-label">Mobile No.<span class="astrict">*</span></label>
            <div class="phone-group">
              <div class="country-code">
                <input list="browsers" class="form-control email-pass-pro ddd" formControlName="countryCode"
                  name="browser" id="browser">
                <datalist id="browsers">
                  <option *ngFor="let code of datas" value="{{code?.phonecode}}">{{code?.flag}}
                    {{code?.phonecode}}
                    {{code?.isoCode}}
                  </option>
                </datalist>
              </div>
              <div class="phone-number">
                <input type="text" placeholder="Enter mobile number" formControlName="Phone"
                  (keypress)="preventSpace($event)" (keypress)="NumOnly($event)" maxlength="15"
                  class="form-control form-control-small" />
              </div>
            </div>
            <div class="for-validation  text-danger"
              *ngIf="addProduct.get('Phone')?.hasError('required') && addProduct.get('Phone')?.touched ">
              *Contact number is required.</div>
            <div class="for-validation  text-danger"
              *ngIf="addProduct.get('Phone')?.hasError('pattern') && addProduct.get('Phone')?.dirty ">
              *Please enter valid number.</div>
            <div class="for-validation text-danger"
              *ngIf="addProduct.get('Phone')?.hasError('minlength') && addProduct.get('Phone')?.dirty ">
              Please enter valid number between 8-15 digit.</div>
            <div class="for-validation text-danger"
              *ngIf="addProduct.get('Phone')?.hasError('maxlength') && addProduct.get('Phone')?.dirty">
              Please enter valid number between 8-15 digit.</div>
          </div>
        </div>
      </div>

      <div class="form-section">
        <div class="section-heading">
          <h3>Address Details</h3>
        </div>
        <div class="form-grid form-grid--two">
          <div class="form-field">
            <label class="form-label">Address<span class="astrict">*</span></label>
            <input ngx-google-places-autocomplete [options]="options" #placesRef="ngx-places" #addressInput
              (onAddressChange)="handleAddressChange($event)" placeholder="Enter Address"
              formControlName="address" maxlength="150" class="form-control form-control-small" />
            <div class="for-validation text-danger"
              *ngIf="addProduct.get('address')?.hasError('required') && addProduct.get('address')?.touched ">
              *Address1 is required.</div>
          </div>

          <div class="form-field">
            <label class="form-label">Address 1</label>
            <input type="text" placeholder="Enter Address 2" formControlName="address1"
              (keypress)="preventSpace($event)" maxlength="250" class="form-control form-control-small" />
          </div>
        </div>
      </div>

      <div class="form-section">
        <div class="section-heading">
          <h3>Location</h3>
        </div>
        <div class="form-grid form-grid--two">
          <div class="form-field">
            <label class="form-label">Country<span class="astrict">*</span></label>
            <select class="form-control email-pass-pro" formControlName="country"
              *ngIf="!completedAddress_country" (change)="getStateList($event)">
              <option value="" selected>Select your country</option>
              <option *ngFor="let item of countryList" [value]="item.isoCode">
                {{item?.name}}
              </option>
            </select>
            <input type="text" *ngIf="completedAddress_country" formControlName="country"
              placeholder="Enter Your Country" readonly class="form-control" />
          </div>

          <div class="form-field">
            <label class="form-label">State</label>
            <select class="form-control email-pass-pro" formControlName="state"
              *ngIf="!completedAddress_state" (change)="getCityList($event)">
              <option value="" selected>Select your state</option>
              <option *ngFor="let item of stateList" [value]="item.isoCode">{{item?.name}}</option>
            </select>
            <input type="text" *ngIf="completedAddress_state" formControlName="state"
              placeholder="Enter Your State" readonly class="form-control" />
          </div>

          <div class="form-field">
            <label class="form-label">City</label>
            <select class="form-control email-pass-pro" formControlName="city"
              *ngIf="!completedAddress_city">
              <option value="" selected>Select your city</option>
              <option *ngFor="let item of cityList" [value]="item.name">{{item?.name}}</option>
            </select>
            <input type="text" *ngIf="completedAddress_city" formControlName="city"
              placeholder="Enter Your City" readonly class="form-control" />
          </div>

          <div class="form-field">
            <label class="form-label">Zip Code<span class="astrict">*</span></label>
            <div class="input-control">
              <input type="text" *ngIf="!completedAddress_zip" formControlName="zipCode"
                placeholder="Enter Zip Code" (keypress)="preventSpace($event)" class="form-control"
                maxlength="10" />
              <input type="text" *ngIf="completedAddress_zip" formControlName="zipCode"
                placeholder="Enter Zip Code" class="form-control mt-2" readonly />
            </div>
            <div class="for-validation text-danger mt-1 mb-1"
              *ngIf="addProduct.get('zipCode')?.hasError('required') && addProduct.get('zipCode')?.touched">
              *Zip code is required.</div>
            <div class="for-validation text-danger"
              *ngIf="addProduct.get('zipCode')?.hasError('pattern') && addProduct.get('zipCode')?.dirty">
              *Please enter valid zipcode.
            </div>
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn-secondary-action" type="button" routerLink="/customer-profile">
          <i class="fa fa-arrow-left mr-2"></i>Back
        </button>
        <button class="btn-primary-action" [disabled]="addProduct.invalid"
          (click)="editProfileDetail()" type="submit">
          <i class="fa fa-check mr-2"></i>Update Profile
        </button>
      </div>
    </form>
  </section>
</div>